import { render, staticRenderFns } from "./FormsPage.vue?vue&type=template&id=c7b6e93a&scoped=true"
import script from "./FormsPage.vue?vue&type=script&lang=js"
export * from "./FormsPage.vue?vue&type=script&lang=js"
import style0 from "./FormsPage.vue?vue&type=style&index=0&id=c7b6e93a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b6e93a",
  null
  
)

export default component.exports